"use client";

import type { ClubSource } from "@/types/discover";
import { useClubContactTracking } from "@/hooks/useClubContactTracking";
import { hasClubCallToAction } from "@/utils/clubCallToAction";
import { useTranslations } from "next-intl";
import { useState } from "react";
import { ContactFormDialog } from "./ContactFormDialog";
import Cta from "./Cta";

export default function MobileClubCtaFooter(props: { club: ClubSource }) {
  const t = useTranslations();
  const label = t("signup.ctaClub");
  const [showContactForm, setShowContactForm] = useState(false);
  const { trackContactClick } = useClubContactTracking({
    clubId: props.club.id,
    isSpondClub: props.club.is_spond_club,
  });

  if (!hasClubCallToAction(props.club)) {
    return null;
  }

  if (props.club.is_spond_club) {
    return (
      <footer className="sm:hidden fixed inset-x-0 bottom-0 z-50 bg-background pb-[env(safe-area-inset-bottom)] shadow-[0px_-2px_4px_-2px_rgba(0,0,0,0.1),_0px_-4px_6px_1px_rgba(0,0,0,0.1)]">
        <div className="mx-auto p-6 pt-4">
          <Cta
            href={props.club.signup_url}
            withRegistrationSource
            label={label}
            disabled={false}
            variant="brand"
            ctaKind="club"
            clubId={props.club.id}
          />
        </div>
      </footer>
    );
  }

  return (
    <>
      <footer className="sm:hidden fixed inset-x-0 bottom-0 z-50 bg-background pb-[env(safe-area-inset-bottom)] shadow-[0px_-2px_4px_-2px_rgba(0,0,0,0.1),_0px_-4px_6px_1px_rgba(0,0,0,0.1)]">
        <div className="mx-auto p-6 pt-4">
          <Cta
            onClick={() => {
              trackContactClick();
              setShowContactForm(true);
            }}
            label={t("contact.contactUs")}
            ctaKind="none"
            className="flex-1"
          />
        </div>
      </footer>
      <ContactFormDialog
        open={showContactForm}
        onOpenChange={setShowContactForm}
        clubId={props.club.id}
        clubName={props.club.name}
      />
    </>
  );
}
